import Api from '@/services/Api'

export default {

  // Método que llama a la url para crear un chat
  getCovidPatients () {
    return Api().get("/covid-patients");
  },
  getCovidPatientsWithAlarm () {
    return Api().get("/covid-patients-with-alarm");
  },
  getCovidPatientsWithAlarmAndCompany (params) {
    return Api().get("/covid-patients-by-user/"+params);
  },
  updateCovidPatient (params) {
    return Api().put("/covid-patients",params);
  },
  addCovidPatient (params) {
    return Api().post("/covid-patients",params);
  },
  getCovidPatient (params) {
    return Api().get("/covid-patients/"+params);
  },
  deleteCovidPatient (params) {
    return Api().delete("/covid-patients/"+params);
  },
  getCovidPatientByIdentification (params) {
    return Api().get("/covid-patients-by-identificacion/"+params);
  },


}



// WEBPACK FOOTER //
// ./src/services/CovidPatientService.js